import { Intent, Expression } from "../model/intent/types";

export const isContains = (intent: Intent, expression: Expression): boolean => intent.expressions.find(x => x.text === expression.text) !== undefined

export const hasDuplicateExpressions = (intent: Intent): boolean => {
    return Array.from(new Set(intent.expressions.map(x => x.text))).length !== intent.expressions.length;
}

export const getDuplicateExpression = (intent: Intent): string[] => {
    return intent.expressions.map(x => x?.text).filter((v,i,a) => a.indexOf(v) !== i);
}